import * as React from 'react';
import HeaderComponent from 'src/modules/commons/header/Header.component';
import { RootState } from 'src/reducers/RootReducer';
import { connect, Dispatch } from 'react-redux';
import { openModal, OpenModal } from 'src/actions/modal';
import LoginContainer from 'src/modules/modals/login/Login.container';
import RegisterContainer from 'src/modules/modals/register/Register.container';

interface StateProps {
  isLogged?: boolean;
}

interface DispatchProps {
  openModal: (content: JSX.Element) => void;
}

interface Props extends StateProps, DispatchProps {
}

class HeaderContainer extends React.Component<Props> {
  public render(): React.ReactNode {
    return (
      <HeaderComponent
        isLogged={this.props.isLogged}
        login={() => this.login()}
        register={() => this.register()}
      />
    );
  }

  private login(): void {
    this.props.openModal(
      <LoginContainer/>
    );
  }

  private register(): void {
    this.props.openModal(
      <RegisterContainer/>
    );
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>): DispatchProps => ({
  openModal: (component: JSX.Element): OpenModal => (
    dispatch(openModal(component))
  )
});

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  isLogged: state.authentication.isLogged,
});

export default connect(mapStateToProps, mapDispatchToProps)(HeaderContainer);



// WEBPACK FOOTER //
// ./src/modules/commons/header/Header.container.tsx